import getRandomInt from '../functions/getRandomInt';
import uqnJoin from '../functions/uqnJoin';
//import getRandomIntArray from '../functions/getRandomIntArray';
export default function random(type, intType) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(1, 3);
    }
    if (type == 1) { // f(x)
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 6);
        }
        let a = getRandomInt(1, 9);
        let b = 0; // for trigo type integrals
        const c = getRandomInt(1, 9);
        let sign = 0; // for trigo type integrals
        if (intType < 5) { // fraction type integrals
            b = getRandomInt(1, 9);
            if (intType == 4) { // for completing square type integral
                sign = getRandomInt(0, 3);
                while (b * 4 == a * a) {
                    b = getRandomInt(1, 9);
                    a = getRandomInt(1, 9);
                }
            }
        }
        return uqnJoin([type, intType, a, b, c, sign]);
    }
    else if (type == 2) { // f(y)
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 6);
        }
        let a = getRandomInt(1, 9);
        let b = 0; // for exp type integral
        const c = getRandomInt(1, 9);
        let sign = 0; // for intType 3,4: perfect squares
        if (intType == 0) { // intType 0: a+by,
            b = getRandomInt(1, 9);
        }
        else if (intType < 3) { // 1: sqrt(a+by), 2: cube root (a+by)
            b = getRandomInt(1, 9);
            sign = getRandomInt(0, 2); // disallow double negatives
        }
        else if (intType < 5) { // intType 3: arc tan, 4: ln
            b = getRandomInt(1, 9);
        }
        else if (intType == 5) { // 5: complete square
            b = getRandomInt(1, 9);
            while (b * 4 == a * a) {
                b = getRandomInt(1, 9);
                a = getRandomInt(1, 9);
            }
            sign = getRandomInt(0, 3);
        }
        return uqnJoin([type, intType, a, b, c, sign]);
    }
    else if (type == 3) { // d2ydx2
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 4);
        }
        let a = getRandomInt(1, 9);
        let b = getRandomInt(1, 9);
        let c = getRandomInt(1, 9);
        let sign = getRandomInt(0, 7);
        return uqnJoin([type, intType, a, b, c, sign]);
    }
    else {
        throw "type out of bounds";
    }
}
